import { useState, useEffect } from 'react'
import { Row, Col, Spin } from 'antd'
import { WeaverQuery } from 'Services/WeaverUtils'
import { loadNodeData } from './helpers'
import SequencedFormError from './Partials/SequencedFormError'
import SequencedFormConfirmation from './Partials/SequencedFormConfirmation'
import SequencedFormInputForm from './Partials/SequencedFormInputForm'
import PreparedStatement from 'Services/PreparedStatement'
import Promise from 'bluebird'

export default SequencedForm = ({ close, formSequence, formCallback, nodeId, mode = 'create', destroy }) ->

  { formFields, queries = [] } = formSequence
  [error, setError] = useState(undefined)
  [confirmation, setConfirmation] = useState(undefined)
  [dataQueries, setDataQueries] = useState([])

  useEffect( ->
    setDataQueries(
      queries.reduce((acc, { id, data })->
        { acc..., [id]: Object.assign(new PreparedStatement(data.query)) }
      , {})
    )
  , [])

  <Row style={{ width: '100%' }}>
    <Col span={24} style={{ padding: 10 }}>
      {
        if error
          <SequencedFormError error={error} />
        else if confirmation
          <SequencedFormConfirmation confirmation={confirmation} />
        else
          <SequencedFormInputForm
            mode={mode}
            nodeId={nodeId}
            formSequence={formSequence}
            dataQueries={dataQueries}
            setError={setError}
            setConfirmation={setConfirmation}
            formCallback={formCallback}
            destroy={destroy}
          />
      }
    </Col>
  </Row>
